// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

export const resetClaimDebit = () => ({
    type: actions.RESET_TCSM_CLAIM_DEBIT
});



// WEBPACK FOOTER //
// ./src/tcsm/claim-debit/action-creators/reset-claim-debit.js